export const lootBoxes = () => ({
    // admin only & used in /resources/admin/loot-boxes.tss
    types: {
        collection: () => '/lootbox_type',
        generate: () => '/lootbox_type/generate',
    },
    collection: () => '/lootboxes',
    single: (id) => `/lootboxes/${id}`,

    requests: (id?: string) => ({
        collection: `/lootboxes/open_request`,
        // available for user and used in /resources/loot-boxes.ts
        delete: `/lootboxes/${id}/remove_opening_request`,
        open: `/lootboxes/${id}/request_open`,
    }),
});
